import { apiGet } from './client';
import type { WarehouseSellerMappingRow } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { WarehouseSellerMappingRow } from '@/lib/types';

/**
 * 店舗倉庫マッピング一覧を取得
 */
export async function getWarehouseSellerMappings(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<WarehouseSellerMappingRow[]> {
  return apiGet<WarehouseSellerMappingRow[]>(
    `/${accountCode}/warehouse-seller-mappings`,
    authHeaders,
  );
}
